/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { ProductPageHero } from "../blocks/Hero/ProductPageHero";
import { SearchFormLanding } from "../blocks/SearchForm/SearchFormLanding";
import { productTypeTire } from "../constants/productTypes";

export const DealerTiresPage: FunctionComponent = () => {
  return (
    <>
      <ProductPageHero />
      <SearchFormLanding productType={productTypeTire} />
    </>
  );
};
